/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { DrivenEntity } from './driven-entity';
import { Style } from '../../enum/style.enum';
import { SimpleAction } from '../../tool/action/simple-action';

export class GenericDrivenEntity extends DrivenEntity {
  readonly subLabelStyle: Style;

  idField: string;
  labelField: string | string[];
  iconField: string;

  public displayId: boolean;

  constructor(
    idField?: string,
    labelField?: string | string[],
    iconField?: string,
  ) {
    super();
    this.idField = idField ? idField : 'id';
    this.labelField = labelField ? labelField : 'label';
    this.iconField = iconField ? iconField : 'icon';
  }

  /**
   * Return id of object
   */
  getId(): string {
    return this[this.idField];
  }

  /**
   * Return the label of object
   */
  getLabel(): string {
    if (typeof this.labelField === 'string') {
      return this[<string>this.labelField];
    } else {
      const labels = [];
      for (const label of this.labelField) {
        labels.push(this[label]);
      }
      return labels.join(' ');
    }
  }

  /**
   * Return the icon of object
   */
  getIcon(): string {
    return this[this.iconField];
  }

  /**
   * Return a string format (id) label1 label2 label3...
   */
  override toString() {
    if (this.labelField instanceof Array) {
      let label = '';
      for (const field of this.labelField) {
        label += ' ' + this[field];
      }
      return `${this.displayId ? `(${this.getId()})` : ''} ${label}`;
    } else {
      return `${this.displayId ? `(${this.getId()})` : ''} ${
        this[this.labelField]
      }`;
    }
  }

  getInfo(): string {
    return '';
  }
  getAlertIcon(): { icon: string; style: Style } {
    return { icon: '', style: undefined };
  }
  getColor(): string {
    return '';
  }
  getDate(): Date {
    return undefined;
  }
  getStatusIcon(): string {
    return '';
  }
  getSubLabel(): string {
    return '';
  }
  isActive(): boolean {
    return false;
  }
  serialize(): any {
    return;
  }
  override convert(item: any): any {
    void item;
    return undefined;
  }
  getApi(): string {
    return '';
  }

  getActions(): SimpleAction<any>[] {
    return [];
  }
}
